import React, { useState } from 'react'

import interfaceSearch from '../../images/global/interface-search.svg'
import interfaceAscending from '../../images/global/interface-ascending.svg'
import interfaceDescending from '../../images/global/interface-descending.svg'

import Link from '../Link'
import Svg from '../SVG'

const Licensees = ({ primary: _primary, licenseePrimary, licensees }) => {
    const primary = licenseePrimary || _primary
    const [showFirst, setShowFirst] = useState(12)
    const [query, setQuery] = useState('')
    const [tag, setTag] = useState([])
    const [asc, setAsc] = useState(true)
    const _tags = licensees?.reduce((tags, { node }) => {
        let newTags = []

        node?.tags?.forEach((tag) => {
            if (tags.indexOf(tag) + newTags.indexOf(tag) === -2)
                newTags.push(tag)
        })

        return [...tags, ...newTags]?.sort((tagA, tagB) => {
            if (tagA < tagB) return -1
            if (tagA > tagB) return 1
            return 0
        })
    }, [])
    const _licensees = licensees
        ?.filter(({ node: { data, tags } }) => {
            let _valid = true

            if (
                tag?.length > 0 &&
                tags?.filter((_tag) => tag?.includes(_tag))?.length === 0
            )
                _valid = false

            if (
                query?.length > 0 &&
                data?.name?.toLowerCase()?.indexOf(query?.toLowerCase()) === -1
            )
                _valid = false

            return _valid
        })
        ?.sort(({ node: { data: dataA } }, { node: { data: dataB } }) => {
            if (dataA?.name < dataB?.name) return asc ? -1 : 1
            if (dataA?.name > dataB?.name) return asc ? 1 : -1
            return 0
        })

    const handleSortClick = () => {
        setAsc(!asc)
    }

    const handleTagClick = (newTag) => {
        if (tag?.includes(newTag)) {
            setTag(tag?.filter((_tag) => _tag !== newTag))
        } else {
            setTag([...tag, newTag])
        }
    }

    return licensees?.length > 0 ? (
        <div className="licensees md:py-20 bg-primary xl:text-left relative py-12 text-center">
            <div className="md:px-12 lg:px-20 container px-8 mx-auto">
                {primary?.heading ? (
                    <h2 className="md:text-3xl lg:text-4xl mt-4 mb-8 text-2xl font-bold">
                        {primary?.heading}
                    </h2>
                ) : null}

                <div className="xl:text-left flex flex-col text-center">
                    <div className="lg:justify-start flex-0 lg:w-1/2 lg:mb-8 flex items-center justify-between w-full">
                        <div className="relative mr-4">
                            <input
                                name="query"
                                type="text"
                                placeholder="Search licensees"
                                value={query}
                                className="border-grey inline-flex items-center flex-1 h-12 px-4 pr-10 border-2 border-opacity-50"
                                onChange={({ currentTarget: { value } }) =>
                                    setQuery(value)
                                }
                            />
                            <Svg
                                src={interfaceSearch}
                                className="top-1/2 right-3 absolute w-4 h-auto transform -translate-y-1/2"
                            />
                        </div>

                        <button
                            type="button"
                            className="border-grey inline-flex items-center justify-center h-12 px-4 text-center border-2 border-opacity-50"
                            onClick={handleSortClick}
                        >
                            <Svg
                                src={
                                    asc
                                        ? interfaceAscending
                                        : interfaceDescending
                                }
                                className="w-4 h-auto"
                            />
                        </button>
                    </div>

                    {primary?.description?.html ? (
                        <div
                            className="lg:mt-0 lg:mb-8 mt-8 mb-4 text-left"
                            dangerouslySetInnerHTML={{
                                __html: primary?.description?.html,
                            }}
                        />
                    ) : null}

                    <div className="flex-0 lg:mt-0 w-full mt-4">
                        {_tags?.length ? (
                            <div className="lg:flex-row lg:items-center lg:justify-start flex flex-col items-start -m-2">
                                <span className="flex-0 p-2 text-xs">
                                    Shop by category:
                                </span>

                                <div className="flex flex-wrap items-center justify-start flex-1 p-2">
                                    <button
                                        className={`inline-flex items-center justify-center h-8 px-2 m-1 border border-grey ${
                                            tag?.length === 0
                                                ? 'bg-grey bg-opacity-30 border-opacity-0'
                                                : 'bg-transparent border-opacity-30'
                                        } text-xxs md:text-xs text-center appearance-none`}
                                        onClick={() => setTag([])}
                                    >
                                        All Products
                                    </button>

                                    {_tags?.map((_tag, i) => (
                                        <button
                                            key={i}
                                            className={`inline-flex items-center justify-center h-8 px-2 m-1 border border-grey ${
                                                tag?.includes(_tag)
                                                    ? 'bg-grey bg-opacity-30 border-opacity-0'
                                                    : 'bg-transparent border-opacity-30'
                                            } text-xxs md:text-xs text-center appearance-none`}
                                            onClick={() => handleTagClick(_tag)}
                                        >
                                            {_tag}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>

                {_licensees?.map(({ node }, _index) => (
                    <div
                        key={_index}
                        className={`mt-8 md:mt-12 pt-8 md:pt-12 border-t-4 border-grey border-opacity-50 ${
                            _index >= showFirst ? 'hidden' : 'block'
                        }`}
                    >
                        <div className="xl:flex-row xl:justify-between flex flex-col items-center justify-center">
                            <div className="flex-0">
                                {node?.data?.name ? (
                                    <h2 className="md:text-2xl text-xl font-bold">
                                        {node?.data?.name}
                                    </h2>
                                ) : null}
                                {node?.data?.bio?.html ? (
                                    <div
                                        className="text-navy mt-2 text-sm text-opacity-50"
                                        dangerouslySetInnerHTML={{
                                            __html: node?.data?.bio?.html,
                                        }}
                                    />
                                ) : null}
                            </div>

                            {node?.tags?.length ? (
                                <div className="xl:justify-end xl:-mt-1 flex flex-wrap items-center justify-center mt-2 -m-1">
                                    {node?.tags?.map((tag, i) => (
                                        <div className="p-1">
                                            <span
                                                key={i}
                                                className="bg-grey bg-opacity-30 inline-flex items-center justify-center h-6 px-2 text-xs"
                                            >
                                                {tag}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                        {node?.data?.link?.url ? (
                            <Link
                                to={node?.data?.link?.url}
                                external={true}
                                className="group sm:w-auto hover:scale-110 bg-blue inline-flex items-center justify-center w-full h-12 px-8 mt-4 text-sm font-bold text-white uppercase transition duration-200 transform cursor-pointer"
                            >
                                View Website
                            </Link>
                        ) : null}
                    </div>
                ))}

                {_licensees?.length && _licensees?.length > showFirst ? (
                    <div className="md:mt-12 md:pt-12 border-grey flex flex-col items-center justify-center pt-8 mt-8 text-center border-t-2 border-opacity-50">
                        <span className="mb-4 text-sm text-black text-opacity-50">
                            Showing {showFirst} of {_licensees?.length}{' '}
                            licensees
                        </span>
                        <button
                            type="button"
                            className="group h-14 sm:mt-0 text-md bg-blue hover:bg-greyblue hover:scale-110 delay-400 inline-flex items-center justify-center px-12 mt-4 font-bold text-white uppercase transition duration-200 transform translate-y-0 opacity-100 cursor-pointer"
                            onClick={() => setShowFirst(showFirst + 12)}
                        >
                            Show more
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    ) : null
}

export default Licensees
